import * as actionTypes from '../action-types'

const initialState = 0;


export default function msgNum(state = initialState, action = {}) {
    switch (action.type) {
        case actionTypes.MSG_NUM_UPDATE:
            return action.msgNum;
        default:
            return state
    }
}
